import React from "react";
import { Modal } from "react-bootstrap";

const ContinueConfirmationModal = ({
  show,
  handleClose,
  continueToAgent,
  type,
}) => {
  return (
    <Modal show={show} onHide={handleClose} size="md">
      <Modal.Header closeButton className="save-closing">
        <Modal.Title className="text-white save-close-title">
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="continue-confirm pt-3">
          {type === "closing" ? (
            <>
              Please ensure that closing office details entered are correct.
              Select 'Yes' to proceed and 'No' to update.
            </>
          ) : (
            <>
              Please ensure that Buyer and Co-Buyer details (if applicable) are
              correct, as no changes can be made once this page is submitted.
              Select 'Yes' to proceed and 'No' to update.
            </>
          )}
        </p>
        <div className="text-center p-2">
          <button
            className="continue-confirm-btn mx-2"
            onClick={continueToAgent}
          >
            Yes
          </button>
          <button className="continue-confirm-btn" onClick={handleClose}>
            No
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ContinueConfirmationModal;
